import FEATURE_FLAGS from 'Constants/feature-flags'

const notificationsConfig = [
  {
    title: 'New Ticket Notification',
    description: 'Sent when new tickets are created',
    key: 'new_tickets',
    type: 'boolean'
  },
  {
    title: 'Ticket Assigned',
    description: 'Notify me when Tickets are assigned to me',
    key: 'assigned_tickets',
    type: 'boolean',
    requiredFeatures: [FEATURE_FLAGS.CONVERSATIONAL_TICKETING]
  },
  {
    title: 'Ticket Subscribed',
    description: 'Notify me when there are replies to subscribed notification',
    key: 'subscribed_tickets',
    type: 'boolean',
    requiredFeatures: [FEATURE_FLAGS.CONVERSATIONAL_TICKETING]
  }
]

export default notificationsConfig
